<template>
  <v-card-text class="overline pa-0">
    <span class="dot" :style="`--color: ${color}`"></span>
    {{ tag.title }}</v-card-text
  >
</template>

<style scoped>
.dot {
  height: 10px;
  width: 10px;
  background-color: var(--color);
  display: inline-block;
}
</style>

<script>
export default {
    props: ['tag','color']
}
</script>
